import { Button, Stack, Typography } from '@mui/material'
import React, { useContext } from 'react'
import API from '../../../../../../services/API'
import { GlobalContext } from '../../../../../../App'

const ConfirmDelete = ({ s3key, dbsID, employeeID, onClose, loadEmployee }) => {
  const { setToast } = useContext(GlobalContext)
  const handleDelete = () => {
    API.post('/employees/delete-dbs-check', {
      s3key,
      dbsID,
      employeeID,
    }).then((res) => {
      if (res.status === 200) {
        onClose()
        setToast({ message: 'DBS Check Deleted' })
        loadEmployee()
      } else {
        setToast({
          message: 'Unable to delete. Please try again later.',
          severity: 'error',
        })
      }
    })
  }

  return (
    <Stack gap={1} alignItems="center">
      <Typography variant="title3" textAlign="center">
        Are you sure you want to delete this DBS check?
      </Typography>
      <Typography variant="caption">This cannot be undone</Typography>
      <Button
        variant="outlined"
        color="info"
        onClick={() => onClose()}
        fullWidth
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        color="error"
        onClick={handleDelete}
        fullWidth
      >
        Delete
      </Button>
    </Stack>
  )
}

export default ConfirmDelete
